import React, { FC, useState, useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter'

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    width: '300px',
    height: '48px',
    marginBottom: theme.spacing(3),
    '&:hover .MuiInput-underline:before ': {
      borderBottom: `1px solid ${theme.palette.primary.main}`,
    },
    '& .MuiInput-underline:after ': {
      borderBottom: `1px solid ${theme.palette.info.light}`,
    },
    '& .MuiInputBase-input': {
      fontSize: 14,
      fontWeight: 500,
    },
    '& label.Mui-error': {
      color: '#3E3E3E',
    },
  },
}))

interface IFormTextFieldPassword {
  props?: TextFieldProps
  name: string
  label: string
}

export const InputFieldPassword: FC<IFormTextFieldPassword> = ({ props, name, label }) => {
  const classes = useStyles()
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const error = errors[name]

  const errorMessage = useMemo(() => {
    const message = error?.message.replace(name, '')
    return capitalizeFirstLetter(message)
  }, [error?.message, name])

  interface State {
    password: string
    showPassword: boolean
  }

  const [values, setValues] = useState<State>({
    password: '',
    showPassword: false,
  })

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword })
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        defaultValue={''}
        render={({ field }) => (
          <TextField
            {...field}
            {...props}
            error={!!error}
            variant={'standard'}
            type={values.showPassword ? 'text' : 'password'}
            label={label}
            className={classes.input}
            helperText={errorMessage}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </>
  )
}

//
// import React, { FC } from 'react'
// import { useFormContext } from 'react-hook-form'
//
// import { FormControl, FormHelperText, Grid, IconButton, Input, InputAdornment, InputLabel } from '@material-ui/core'
// import { makeStyles } from '@material-ui/core/styles'
// import { Visibility, VisibilityOff } from '@material-ui/icons'
//
// import { errorMessage } from '../../../constants/errorMessages'
//
// const useStyles = makeStyles((theme) => ({
//   inputContainer: {
//     marginBottom: 5,
//     width: 300,
//     height: '69px',
//   },
//   label: {
//     fontSize: 16,
//     // marginBottom: '5px',
//     color: theme.palette.primary.main,
//     opacity: 0.72,
//   },
//   formControl: {
//     width: 300,
//     height: 35,
//     boxSizing: 'border-box',
//     justifyContent: 'flex-end',
//     '&:hover .MuiInput-underline:before ': {
//       borderBottom: `1px solid ${theme.palette.primary.main}`,
//     },
//     '& .MuiInput-underline:after ': {
//       borderBottom: `1px solid ${theme.palette.info.light}`,
//       // },
//       '& .MuiInputBase-input': {
//         fontSize: 14,
//         fontWeight: 500,
//       },
//     },
//     '& .MuiFormHelperText-root': {
//       color: 'red',
//     },
//   },
//   errorStyle: {
//     color: theme.palette.error.main,
//   },
// }))
//
// interface InputFieldProps {
//   labelName: string
//   inputName: string
//   inputType: string
//   required: boolean
//   matched?: any
// }
//
// export const InputFieldPassword: FC<InputFieldProps> = ({ labelName, inputName, required, matched }) => {
//   const { label, inputContainer, formControl, errorStyle } = useStyles()
//   const {
//     register,
//     formState: { errors },
//   } = useFormContext()
//   const error = errors.password
//
//   interface State {
//     password: string
//     showPassword: boolean
//   }
//
//   const [values, setValues] = React.useState<State>({
//     password: '',
//     showPassword: false,
//   })
//
//   const handleChange = (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
//     setValues({ ...values, [prop]: event.target.value })
//   }
//
//   const handleClickShowPassword = () => {
//     setValues({ ...values, showPassword: !values.showPassword })
//   }
//
//   const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.preventDefault()
//   }
//   return (
//     <Grid container item className={inputContainer} direction={'column'} wrap={'nowrap'}>
//       <Grid item>
//         <InputLabel shrink htmlFor={inputName} className={label}>
//           {labelName}
//         </InputLabel>
//       </Grid>
//       <Grid item>
//         <FormControl size={'small'} className={formControl}>
//           <Input
//             {...register(inputName, { required })}
//             type={values.showPassword ? 'text' : 'password'}
//             defaultValue={''}
//             // error={!!error}
//             id={inputName}
//             color={'primary'}
//             onChange={handleChange('password')}
//             endAdornment={
//               <InputAdornment position="end">
//                 <IconButton
//                   aria-label="toggle password visibility"
//                   onClick={handleClickShowPassword}
//                   onMouseDown={handleMouseDownPassword}
//                 >
//                   {values.showPassword ? <Visibility /> : <VisibilityOff />}
//                 </IconButton>
//               </InputAdornment>
//             }
//           />
//         </FormControl>
//       </Grid>
//       <Grid item>
//         {error && (
//           <FormHelperText id="component-error-text" className={errorStyle}>
//             {errorMessage.EMPTY_FIELD}
//             {/* {!matched && errorMessage.PASSWORD_NOT_MATCH} */}
//           </FormHelperText>
//         )}
//       </Grid>
//     </Grid>
//   )
// }
